'use client'
import {
  transition_default
} from "./chunk-RXCYWA6Q.mjs";
import {
  z_index_default
} from "./chunk-5QZEG2IM.mjs";
import {
  borders_default
} from "./chunk-PE5G6LAZ.mjs";
import {
  breakpoints_default
} from "./chunk-ZCARTYDH.mjs";
import {
  colors_default
} from "./chunk-OFZWI3IK.mjs";
import {
  radius_default
} from "./chunk-AMMMMB27.mjs";
import {
  shadows_default
} from "./chunk-A3OO4VZD.mjs";
import {
  blur_default
} from "./chunk-EXHLCVSK.mjs";
import {
  typography_default
} from "./chunk-VW4MZLZF.mjs";
import {
  sizes_default
} from "./chunk-QH74K4BV.mjs";
import {
  spacing
} from "./chunk-NIUVG5KM.mjs";

// src/foundations/index.ts
var foundations = {
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default,
  ...typography_default,
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
};

export {
  foundations
};
//# sourceMappingURL=chunk-5FMCT5RQ.mjs.map